var _g, _path, _g2, _g3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "625 385 30 30",
    enableBackground: "new 625 385 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 640,
    cy: 400,
    r: 13.533
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M626,386h28v28h-28V386z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FF4343",
    cx: 640,
    cy: 400,
    r: 11.55
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4916.666,
    y: 1866.667,
    fill: "#FF4343",
    width: 14590,
    height: 10916.665
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M639.066,404.783c0,0.467,0.35,0.934,0.934,0.934c0.583,0,0.934-0.467,0.934-0.934s-0.351-0.934-0.934-0.934 C639.417,403.85,639.066,404.316,639.066,404.783z M639.066,391.367v3.85h1.867v-1.867c3.267,0.467,5.717,3.267,5.717,6.65 c0,3.733-2.917,6.65-6.65,6.65s-6.65-2.917-6.65-6.65c0-1.633,0.583-3.033,1.517-4.2l5.133,5.134l1.283-1.284l-6.417-6.533l0,0 c-2.1,1.517-3.5,4.083-3.5,6.883c0,4.783,3.85,8.634,8.633,8.634s8.634-3.851,8.634-8.634s-3.851-8.633-8.634-8.633H639.066z  M645.717,400c0-0.583-0.467-0.934-0.934-0.934s-0.934,0.35-0.934,0.934c0,0.583,0.467,0.934,0.934,0.934 S645.717,400.583,645.717,400z M634.283,400c0,0.583,0.35,0.934,0.934,0.934c0.583,0,0.933-0.351,0.933-0.934 c0-0.583-0.35-0.934-0.933-0.934C634.633,399.066,634.283,399.417,634.283,400z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.88fcd513a1e3ee6089a6eca75b8d6459.svg";
export { ForwardRef as ReactComponent };